import React from 'react';
import classNames from 'classnames';

import { FieldTextInput } from '../../components';

import css from './authForm.module.css';

/**
 * Final Form text field styled to the Dear Danielle auth inputs:
 * 16px-radius outline, leading icon, 14px labels.
 *
 * @component
 * @param {Object} props FieldTextInput props plus icon
 * @param {string} props.icon URL of the 16×16 leading icon
 * @param {string?} props.className extra class on the field wrapper
 * @param {React.ReactNode?} props.endAdornment control rendered inside the input (e.g. show-password)
 * @returns {JSX.Element}
 */
const AuthTextField = props => {
  const { icon, className, endAdornment, ...rest } = props;
  return (
    <div className={classNames(css.field, className)}>
      {icon ? <img className={css.iconStart} src={icon} alt="" width={16} height={16} /> : null}
      <FieldTextInput
        inputRootClass={css.input}
        labelClassName={css.label}
        hidePasswordToggle={!!endAdornment}
        {...rest}
      />
      {endAdornment}
    </div>
  );
};

export default AuthTextField;
